module.exports = __webpack_public_path__ + "static/media/clock-icon.84da2519.svg";